import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.css';

const ModalBody = props => (
  <div className={styles.nurtureModalContent}>
    {props.children}
  </div>
);

export default ModalBody;

ModalBody.propTypes = {
  children: PropTypes.node.isRequired,
};
